import MapFilter from './TitleSearch';

export default MapFilter;